import Typography, { type TypographyProps } from "@mui/material/Typography";

/** The heading of a section within a page. Renders as an `<h2>`. */
export function SectionTitle(props: TypographyProps) {
  return <Typography variant="h6" component="h2" {...props} />;
}
